<div class="privacy-disclaimer mb-footer">
    <div class="banner" *ngIf="isLang == 'id'">
        <app-banner-header [dataBanner]="dataBanner" [fontSize]="'long-word'"></app-banner-header>
    </div>
    <div class="banner" *ngIf="isLang == 'en'">
        <app-banner-header [dataBanner]="dataBanner"></app-banner-header>
    </div>
    <div class="page-able mt-md-5 mt-4">
        <div class="container">
            <div class="row">
                <div class="col-md-11 mx-auto">
                    <div class="desc text-justify no-list list-circle padlist" [innerHTML]="dataSection?.content"></div>
                </div>
            </div>
        </div>
    </div>
</div>

